import FlickityClass from "common/utils/ui/flickity-class";
import "./digital-assets-pdp-image.scss";

export default () =>
  new FlickityClass(".js-digital-assets-pdp-image-carousel", {
    pageDots: false,
    wrapAround: true,
    fade: true
  }).initFlickity();
